import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Container } from 'react-bootstrap';

import { Ai2Layout } from '../layout/Ai2Layout';

import activityFundingIcon from '../../assets/img/activity-funding-demo.png';

const ActivityFunding = () => {
  return (
    <Ai2Layout>
      <div className="ui">
        <Container fluid>
          <div className="flexVert offsetNavbar ">
            <div className="activityFundingImage">
              <img
                width={'1440px'}
                src={activityFundingIcon}
                alt="Activity Funding Demo"
                draggable="false" // Prevent image dragging
                style={{ userSelect: 'none' }} // Prevent image selection
              />
            </div>
          </div>
        </Container>
      </div>
    </Ai2Layout>
  );
};

export { ActivityFunding };
